import {Component, OnInit, ChangeDetectorRef, ViewChild, ViewContainerRef, OnDestroy} from '@angular/core';
import {IConfigureWizard, IWorkflowStepComponent} from '@shared/interfaces/workflow-step.interface';
import { WorkflowModel, WorkflowState } from '../../../workflow/models/workflow.model';
import { Observable, Subject } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { DataSurveyState } from '../../store/reducers/data-survey.reducers';
import { takeUntil } from 'rxjs/operators';
import { getCurrentSurvey } from '../../store/selectors/data-survey.selectors';
import { DialogModel } from '@shared/models/dialog.model';
import { DialogService } from '@shared/services/dialog-service';
import {
  ImportFieldSectionIntoDataSurveyCommand,
  DeleteSurveySectionCommand,
  DeleteFieldQuestionCommand,
  UpdateFieldQuestionCommand,
  ImportFieldsFromFileCommand,
  ImportFieldsIntoDataSurveyCommand
} from '../../commands/survey.commands';
import {
  DeleteFieldQuestionAction, DeleteSurveySectionAction,
  GetSurveyAction
} from '../../store/actions/data-survey.actions';
import { CommandService } from '@core/services/command.service';
import { Configuration } from '@shared/models/configuration';
import { SnackBarService } from '@core/services/snack-bar.service';
import {EditSurveyQuestionDialogModel} from '../../models/data-survey.models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {WorkflowWizardComponent} from '../../../workflow/components/workflow-wizard/workflow-wizard.component';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'particle-survey-questions-step',
  templateUrl: './survey-questions-step.component.html',
  styleUrls: ['./survey-questions-step.component.scss']
})
export class SurveyQuestionsStepComponent implements OnInit, IWorkflowStepComponent, IConfigureWizard, OnDestroy {
  currentStep: WorkflowState;
  survey: any;
  isClose = false;
  ngUnsubscribe = new Subject<void>();
  selectedFieldSectionIndex: number;
  selectedSection: any;
  sourceKey: string; // dummy
  currentSectionConfig: any;
  invalidateSubject: InvalidateSubject;
  private hasTabs: boolean;
  private wizard: WorkflowWizardComponent;
  currentView: string;
  endpointName = 'DataSurveyApi';
  workflow: WorkflowModel;
  private fileId: string;
  private fullPath: string;
  excelSourceType: string;
  constructor(public changeDetectorRef: ChangeDetectorRef, private dataSurveyStore: Store<DataSurveyState>,
    private dialogService: DialogService,
    private commandService: CommandService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private snackBarService: SnackBarService) {
    this.sourceKey = 'Data-Survey';
    this.selectedFieldSectionIndex = 0;
    this.invalidateSubject = new InvalidateSubject();
    this.currentView = 'QuestionOption';
   }

  ngOnInit() {
    this.dataSurveyStore.select(getCurrentSurvey).pipe(takeUntil(this.ngUnsubscribe)).subscribe(currentSurvey => {
      this.survey = currentSurvey;
      if (this.survey && this.survey.definitionSections && this.survey.definitionSections.length) {
        this.currentView = 'SurveyFields';
        this.onTabIndexChange(this.selectedFieldSectionIndex);
      } else if (this.survey && (!this.survey.definitionSections || (this.survey.definitionSections && this.survey.definitionSections.length === 0))) {
        this.fuseSplashScreenService.hide();
        this.currentView = 'QuestionOption';
      }
    });
  }
  onLoad(workflow: WorkflowModel, currentStep: WorkflowState) {
    this.workflow = workflow;
    this.currentStep = currentStep;
  }
  canMoveNext$(): Observable<boolean> {
    if (this.currentView === 'ExcelFieldMapping') {
      const nextSubject = new Subject<boolean>();
      const importFieldsCommand = new ImportFieldsIntoDataSurveyCommand(this.fileId, this.fullPath, this.workflow.Id, this.survey.id);
      this.commandService.executeCommand(importFieldsCommand)
        .pipe(takeUntil(this.ngUnsubscribe)).subscribe(commandState => {
        this.currentView = 'SurveyFields';
        this.getCurrentSurvey();

      });
      return nextSubject.asObservable();
    }
    return null;
  }
  canMoveNext(): boolean {
    if (!this.survey.definitionSections || this.survey.definitionSections.length === 0 || this.currentView === 'QuestionOption') {
      this.snackBarService.showError('Please select questions');
      return false;
    }
    if (this.selectedFieldSectionIndex < this.survey.definitionSections.length - 1) {
      this.selectedFieldSectionIndex++;
      this.onTabIndexChange(this.selectedFieldSectionIndex);
      return false;
    }
    return true;
  }
  canCancel(): boolean {
    console.log('onBeforeCancel at WorkflowGridStepComponent');
    return true;
  }
  importFieldSections() {
    const dialogModel: DialogModel = DialogModel.create(
      'Select ITP Fields',
      'ImportFieldSectionsComponent', { 'surveyId': this.survey.id },
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        console.log('import sections dialog:', res);
        const command = new ImportFieldSectionIntoDataSurveyCommand(this.survey.id);
        this.commandService.executeCommand(command)
        .pipe(takeUntil(this.ngUnsubscribe)).subscribe(commandState => {
            this.getCurrentSurvey();
        });
      }
    });
  }
  getCurrentSurvey() {
    this.dataSurveyStore.dispatch(new GetSurveyAction(this.survey.id));
  }

  onTabIndexChange(event) {
    this.selectedFieldSectionIndex = event;
    this.selectedSection = this.survey.definitionSections[event];
    if (this.selectedSection && this.selectedSection.config && this.selectedSection.config.Editor === 'DataSurveyFieldDefinitionSelectorComponent') {
      this.setVirtualGridParameters();
    }
    if (this.wizard) {
      this.wizard.hasTabs = this.survey.definitionSections.length > 1;
    }
  }

  setVirtualGridParameters() {
    this.currentSectionConfig = Configuration.getSmartGridConfig(this.selectedSection.config.ConfigKey);
    this.currentSectionConfig.Parameters['EXECUTION_ID'] = this.selectedSection.config.EXECUTION_ID;
    this.invalidateSubject.invalidate();
  }
  moveCheckItem() {
}

  onAddQuestion() {
    console.log(this.selectedSection);
    const dialogModel: DialogModel = DialogModel.create(
      'Custom Survey Builder',
      'AddQuestionDialogComponent', { 'survey': this.survey, 'selectedSection': this.selectedSection },
      '700px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log('add question:', res);
      if (res.action === 'OK') {
        this.commandService.executeCommand(res.data.input.command)
        .pipe(takeUntil(this.ngUnsubscribe)).subscribe(commandState => {
          this.selectedFieldSectionIndex = this.survey.definitionSections.findIndex(section => section.sectionId === res.data.input.command.sectionId);
          if (this.selectedFieldSectionIndex === -1) {
            this.selectedFieldSectionIndex = 0;
          }
          this.onTabIndexChange(this.selectedFieldSectionIndex);
        });
      }
    });
  }
  removeSection() {
    const removeSectionCommand = new DeleteSurveySectionCommand(this.survey.id, this.selectedSection.sectionId);
    console.log('remove section:', removeSectionCommand);
    this.dataSurveyStore.dispatch(new DeleteSurveySectionAction(removeSectionCommand));
  }
  onUploadExcelTemplate() {
    const dialogModel: DialogModel = DialogModel.create(
      'Upload Excel Template',
      'ImportFieldFromTemplateDialogComponent', { 'survey': this.survey, 'selectedSection': this.selectedSection},
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log('import fields:', res);
      if (res.action === 'OK') {
        this.fileId = res.data.input.fileId;
        this.fullPath = res.data.input.fullPath;
        this.getImportFieldsWorksheetDetails(this.fileId, this.fullPath);
      }
    });
  }
  getImportFieldsWorksheetDetails(fileId: string, fullPath: string) {
    const importFieldsCommand = new ImportFieldsFromFileCommand(fileId, fullPath, this.workflow.Id, false);
    this.commandService.executeCommand(importFieldsCommand)
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe(commandState => {
      console.log('worksheets:', commandState);
      this.currentView = 'ExcelFieldMapping';
    });
  }
  onGridCellValueChange($event) {
    console.log('action from edit question:', $event, this.survey.definitionSections, this.selectedFieldSectionIndex);
    if ($event.action.text === 'Edit') {
      const editFieldQuestionDetails = new EditSurveyQuestionDialogModel();
      editFieldQuestionDetails.questionDetails = $event.item.cells['FieldDefinition'].value;
      editFieldQuestionDetails.selectedSection = this.selectedSection;
      editFieldQuestionDetails.disableDataTypeEdit = this.survey.definitionSections[this.selectedFieldSectionIndex].toolName !== 'Custom' && this.survey.definitionSections[this.selectedFieldSectionIndex].toolHeader !== 'Custom';
      editFieldQuestionDetails.hideSettings = this.survey.definitionSections[this.selectedFieldSectionIndex].toolName !== 'Custom' && this.survey.definitionSections[this.selectedFieldSectionIndex].toolHeader !== 'Custom';
      const dialogModel: DialogModel = DialogModel.create(
        `Edit Field ${editFieldQuestionDetails.questionDetails && editFieldQuestionDetails.questionDetails.header ? ' (' + editFieldQuestionDetails.questionDetails.header + ')' : ''}`,
        'EditQuestionDialogComponent', { 'editFieldQuestionDetails': editFieldQuestionDetails },
        '700px',
        '700px'
      );
      this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
        console.log('edit question:', res);
        if (res.action === 'OK') {
          const command = new UpdateFieldQuestionCommand(this.survey.id,
            res.data.input.editFieldQuestionDetails.selectedSection.sectionId,
            this.selectedSection.sectionId,
            res.data.input.editFieldQuestionDetails.questionDetails.header,
            res.data.input.editFieldQuestionDetails.questionDetails.instruction,
            res.data.input.editFieldQuestionDetails.questionDetails.key,
            res.data.input.editFieldQuestionDetails.questionDetails.isMandatory,
            res.data.input.editFieldQuestionDetails.questionDetails.dataType,
            res.data.input.editFieldQuestionDetails.questionDetails.options
          );
          this.commandService.executeCommand(command)
            .pipe(takeUntil(this.ngUnsubscribe)).subscribe(commandState => {
            this.selectedFieldSectionIndex = this.survey.definitionSections.findIndex(section => section.sectionId === res.data.input.editFieldQuestionDetails.selectedSection.sectionId);
            if (this.selectedFieldSectionIndex === -1) {
              this.selectedFieldSectionIndex = 0;
            }
            this.onTabIndexChange(this.selectedFieldSectionIndex);
          });
        }
      });
    } else if ($event.action.text === 'Delete') {
      if ($event.item.cells['Key']) {
        const deleteFieldQuestionCommand = new DeleteFieldQuestionCommand(this.survey.id, this.selectedSection.sectionId, $event.item.cells['Key'].value, $event.item.id);
        this.dataSurveyStore.dispatch(new DeleteFieldQuestionAction(deleteFieldQuestionCommand));
      }
    }
  }
  private getPermissionId(id: string): number {
    switch (id) {
      case 'Read':
        return 0;
      case 'Read Only':
        return 0;
      case 'Write':
        return 1;
      case 'Write Only':
        return 1;
      case 'Read-Write':
        return 2;
    }
    return -1;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  setWizard(wizard: WorkflowWizardComponent) {
    this.wizard = wizard;
  }
  close() {
    this.isClose = true;
  }
}
